import React, { useEffect, useState } from "react";
import StyledHeadingText from "../../../components/Fonts/StyledHeadingText";
import Table from "../../../components/tables/Table";
import { toast } from "react-toastify";
import { getHudPatientsOintments, getHudPatientsTablets } from "../../../services/hud/hud_patients";
import CustomLoading from "../../../components/customLoading/CustomLoading";

const PatientMedicineView = ({ patientId, openedFor }) => {
    const [loading, setLoading] = useState(false);
    const headers = [
        { label: "S. No.", key: "i" },
        { label: "Medicines", key: "medicines" },
        { label: "Date", key: "created_at" },
    ];
    const [tableData, setTableData] = useState([]);

    const fetchTabletData = async (patientId) => {
        try {
            let res = await getHudPatientsTablets(patientId);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchOintmentData = async (patientId) => {
        try {
            let res = await getHudPatientsOintments(patientId);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (openedFor === "tablet") {
            fetchTabletData(patientId);
        } else {
            fetchOintmentData(patientId);
        }
    }, [patientId, openedFor]);


    return (
        loading ? <CustomLoading /> :
            <>
                <div className="w-full flex-1">
                    <StyledHeadingText text={"PATIENT " + openedFor.toUpperCase()} size={"mb-2"} />
                    {<Table
                        headers={headers}
                        rows={tableData.map((item, index) => (
                            {
                                i: <p>{index + 1}</p>,
                                created_at: <p>{item.date}</p>,
                                medicines: <p>{item.medicines}</p>,
                            }))}
                    />
                    }
                </div >
            </>
    );
};

export default PatientMedicineView;
